import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link, NavLink, useLocation } from "react-router-dom";
import { decrypt } from "../../utils/encodingdecoding";
import { useDispatch } from "react-redux";
import { my_orders } from "../../Image/Index";

const Sidebar = (props) => {
    const { children } = props;
    const location = useLocation();
    const [toggle, setToggle] = useState(false);

    const [dropdownDocBtn, setDropdownDocBtn] = useState(false);
    const [activeBtn, setActiveBtn] = useState(false);
    const [dropdownSetting, setDropdownSetting] = useState(false);
    const [dropdownSettingBtn, setDropdownSettingBtn] = useState(false);
    const [apiDocBtn, setApiDocBtn] = useState(false);
    const [menuItem, setMenuItem] = useState([]);
    const [menuTree, setMenuTree] = useState([]);
    let Dashboard = sessionStorage.getItem("dashboard");
    const dispatch = useDispatch();
    const [key, setKey] = useState(true);

    useEffect(() => {
        if (localStorage.getItem("firstLogin")) setToggle(true);
        if (location.pathname.includes("customers-list")) {
            let tempCusPageIndex = JSON.parse(localStorage.getItem("CusPageIndex"));
            localStorage.setItem("CusPageIndex", JSON.stringify(tempCusPageIndex));
        } else {
            localStorage.setItem("CusPageIndex", JSON.stringify(1));
        }
        if (location.pathname.includes("transactions-list")) {
            let tempTransPageIndex = JSON.parse(localStorage.getItem("TransPageIndex"));
            localStorage.setItem("TransPageIndex", JSON.stringify(tempTransPageIndex));
        } else {
            localStorage.setItem("TransPageIndex", JSON.stringify(1));
        }

        let commTabKey = decrypt(localStorage.getItem("key"));
        let commTabCode = decrypt(localStorage.getItem("code"));

        if (!commTabCode && !commTabKey) {
            return;
        } else {
            localStorage.removeItem("key");
            localStorage.removeItem("code");
        }
    }, [location]);
    useEffect(() => {
        setMenuTree(menuItem);
    }, [menuItem]);

    useEffect(() => {
        setMenuItem(
            window.location.pathname == "/register" || window.location.pathname == "/contact-us-query" || window.location.pathname == "/alertNotification"
                ? [
                      {
                          id: 1,
                          path: "/register",
                          name: "Registerd User",
                          iconOffHover: <img src={"/Images/monitor.png"} alt="" className="offHover" />,
                          iconOnHover: <img src={"/Images/monitor_hover.png"} alt="" className="onHover" />,
                          isChildVisible: false,
                          isActive: false,
                          dropdown: null,
                      },
                      {
                          id: 2,
                          path: "/contact-us-query",
                          name: "Contact-Us Query",
                          iconOffHover: <img src={"/Images/uploadIcon.png"} alt="" className="offHover" />,
                          iconOnHover: <img src={"/Images/uploadIcon.png"} alt="" className="onHover" />,
                          isChildVisible: false,
                          dropdown: null,
                          isActive: false,
                      },
                      {
                          id: 3,
                          path: "/alertNotification",
                          name: "Alert Notification",
                          iconOffHover: <i className="fa-solid fa-bell" style={{ fontSize: "1.2rem" }}></i>,
                          isChildVisible: false,
                          dropdown: null,
                          isActive: false,
                      },
                  ]
                : [
                      {
                          id: 1,
                          path: "/reseller-home",
                          name: "Gift Card ",
                          iconOffHover: <i className="fas fa-gift" style={{ fontSize: "1.2rem" }}></i>,
                          isChildVisible: false,
                          dropdown: null,
                          isActive: false,
                          className: "pro_options",
                      },

                      {
                          id: 2,
                          path: "/reseller-orders",
                          name: "Orders ",
                          iconOnHover: <img src={my_orders} alt="" className="onHover" />,
                          iconOffHover: <img src={my_orders} alt="" className="offHover" />,
                          isChildVisible: false,
                          dropdown: null,
                          isActive: false,
                          className: "pro_options",
                      },
                  ]
        );
    }, []);

    const menuMainTrigger = () => {
        let array = [...menuTree];
        array.forEach((elem) => {
            if (toggle) {
                elem.isActive = false;
                setDropdownDocBtn(false);
                setDropdownSettingBtn(false);
                setDropdownSetting(false);
            }
        });
        setMenuTree(array);
        setToggle(!toggle);
    };
    const childrenMenu = (id, Index, api_doc, path) => {
        location.pathname === path && window.location.reload();
        let array = [...menuTree];
        array.forEach((elem) => {
            if (elem.id === id && elem.dropdown && !toggle) {
                elem.isActive = false;
                elem.isChildVisible = true;
                setDropdownDocBtn(false);
                setDropdownSetting(false);
                setActiveBtn(false);
                setApiDocBtn(false);
            } else if ((id === "btn" && toggle && Index === 2) || api_doc) {
                setDropdownDocBtn(true);
                setActiveBtn(true);
                elem.isChildVisible = false;
                setDropdownSettingBtn(false);
                setDropdownSetting(false);
                api_doc ? setApiDocBtn(true) : setApiDocBtn(false);
            } else if (id === "btn" && toggle && Index === 1) {
                setDropdownSettingBtn(true);
                setDropdownSetting(false);
                elem.isChildVisible = false;
                setDropdownDocBtn(false);
                setActiveBtn(true);
                setApiDocBtn(false);
            } else if (id === "btn" && Index === 1) {
                setDropdownSettingBtn(!dropdownSettingBtn);
                setDropdownSetting(false);
                elem.isChildVisible = false;
                setDropdownDocBtn(false);
                setApiDocBtn(false);
            } else if (id === "btn" && toggle && Index === 3) {
                setDropdownSettingBtn(false);
                setDropdownSetting(true);
                elem.isChildVisible = false;
                setDropdownDocBtn(false);
                setActiveBtn(true);
                setApiDocBtn(false);
            } else if (id === "btn" && Index === 3) {
                setDropdownSetting(!dropdownSetting);
                setDropdownSettingBtn(false);
                elem.isChildVisible = false;
                setDropdownDocBtn(false);
                setApiDocBtn(false);
            } else if ((id === "btn" && Index == 2) || api_doc) {
                setDropdownSettingBtn(false);
                setDropdownSetting(false);
                elem.isChildVisible = false;
                setDropdownDocBtn(!dropdownDocBtn);
                api_doc ? setApiDocBtn(true) : setApiDocBtn(false);
            } else if (toggle === false) {
                setDropdownDocBtn(false);
                setActiveBtn(false);
                setApiDocBtn(false);
                elem.isChildVisible = false;
            }
        });
        setMenuTree(array);
    };
    const menuChildTrigger = async (id, Index, path) => {
        location.pathname === path && window.location.reload();

        let array = [...menuTree];
        await array.forEach((elem) => {
            if (elem.id === id && elem.dropdown) {
                elem.isActive = !elem.isActive;
                setDropdownDocBtn(false);
                setActiveBtn(false);
                setDropdownSettingBtn(false);
                setDropdownSetting(false);
                setApiDocBtn(false);
            } else if (id === "btn" && Index === 3) {
                setDropdownSetting(!dropdownSetting);
                setDropdownSettingBtn(false);
                setDropdownDocBtn(false);
                setActiveBtn(true);
                setApiDocBtn(false);
                elem.isActive = false;
            } else if (id === "btn" && Index === 2) {
                setDropdownDocBtn(!dropdownDocBtn);
                setActiveBtn(true);
                setDropdownSetting(false);
                setDropdownSettingBtn(false);
                elem.isActive = false;
            } else if (id === "btn" && Index === 1) {
                setDropdownSettingBtn(!dropdownSettingBtn);
                setDropdownDocBtn(false);
                setDropdownSetting(false);
                setActiveBtn(true);
                setApiDocBtn(false);
                elem.isActive = false;
            } else {
                setDropdownSettingBtn(false);
                setDropdownSetting(false);
                setDropdownDocBtn(false);
                setActiveBtn(false);
                setApiDocBtn(false);
                elem.isChildVisible = false;
                elem.isActive = false;
            }
        });

        setMenuTree(array);
    };

    const handleLogout = () => {
        if (Dashboard === "UD") {
            if (localStorage.getItem("superAdmin")) {
                localStorage.removeItem("saasemail");
                localStorage.removeItem("superAdmin");
            }
            // localStorage.removeItem("token_gen");
            sessionStorage.clear();
            localStorage.clear();
        } else {
            localStorage.removeItem("saasemail");
            localStorage.removeItem("password");
            sessionStorage.setItem("dashboard", "UD");
        }
    };
    return (
        <>
            <div className={`dashboard ${toggle ? "openSidebar" : ""}`}>
                <div className="dashboard__sidebar" id="sidebar">
                    <div className="dashboard__topSection">
                        <Link to={location.pathname.includes("register") || location.pathname.includes("contact-us-query") || location.pathname.includes("alertNotification") ? "/register" : "/reseller-home"}>
                            <img src={"/Images/logo.png"} alt="" className="dashboard__logoBox" />
                        </Link>
                        <div className="dashboard__menuBox">
                            <span onClick={menuMainTrigger}>
                                <img src={"/Images/close-icon.png"} alt="" className="inside" />
                                <img src={"/Images/open-icon.png"} alt="open-icon.png" className="outside" />
                            </span>
                        </div>
                    </div>

                    <div className="dashboard__menuMain">
                        <div className="dashboard__menuTop">
                            <ul>
                                {window.location.pathname == "/register" || window.location.pathname == "/contact-us-query" || window.location.pathname == "/alertNotification"
                                    ? menuTree.map((elem, index) => {
                                          const { id, name, iconOffHover, iconOnHover, path, className } = elem;
                                          return (
                                              <li key={`parentLi__${index}`} title={name}>
                                                  <div id={className}>
                                                      <NavLink to={path} className="link" onClick={() => menuChildTrigger(id, null, path)}>
                                                          <figure className="icon">
                                                              {iconOffHover}
                                                              {iconOnHover}
                                                          </figure>
                                                          <span className="link_text">{name}</span>
                                                      </NavLink>
                                                  </div>
                                              </li>
                                          );
                                      })
                                    : menuTree.map((elem, index) => {
                                          const { id, name, iconOffHover, iconOnHover, dropdown, path, isChildVisible, isActive, className, ids } = elem;

                                          return (
                                              <ul key={index}>
                                                  <li key={id} title={name}>
                                                      {path ? (
                                                          <div className={module.isEnable === false ? className : ""} id={ids}>
                                                              <NavLink to={path} className="link" onClick={() => menuChildTrigger(id, null, path)}>
                                                                  <figure className="icon">
                                                                      {iconOffHover}
                                                                      {iconOnHover}
                                                                  </figure>
                                                                  <span className="link_text">{name}</span>
                                                              </NavLink>
                                                          </div>
                                                      ) : (
                                                          <div className={module.isEnable === false ? className : ""} id={ids}>
                                                              <button type="button" className={isChildVisible ? "link active" : "link"} onClick={() => menuChildTrigger(id, null)}>
                                                                  <figure className="icon">
                                                                      {iconOffHover}
                                                                      {iconOnHover}
                                                                  </figure>
                                                                  <span className="link_text">{name}</span>
                                                                  {!isActive ? (
                                                                      <span className="link_icon">
                                                                          <i className="fa fa-chevron-right" aria-hidden="true"></i>
                                                                      </span>
                                                                  ) : (
                                                                      <span className="link_icon">
                                                                          <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                                                      </span>
                                                                  )}
                                                              </button>
                                                          </div>
                                                      )}
                                                      {dropdown && isActive && (
                                                          <ul className="childrenDropdown">
                                                              {dropdown.map((each, idx) => {
                                                                  const { path, name } = each;
                                                                  return (
                                                                      <li key={`childLi__${id}__${idx}`} title={name}>
                                                                          <NavLink to={path} onClick={() => childrenMenu(id, null, null, path)}>
                                                                              {name}
                                                                          </NavLink>
                                                                      </li>
                                                                  );
                                                              })}
                                                          </ul>
                                                      )}
                                                  </li>
                                              </ul>
                                          );
                                      })}
                            </ul>
                        </div>

                        <div className="dashboard__menuBottom">
                            <ul>
                                {Dashboard === "UD" && !location.pathname.includes("contact-us-query") && !location.pathname.includes("register") && !location.pathname.includes("alertNotification") && (
                                    <>
                                        <li>
                                            {/* <button className={location.pathname.includes("change-password") || location.pathname.includes("/profile-settings") ? "link active" : "link"} type="button" onClick={() => menuChildTrigger("btn", 1)}>
                                                <figure className="icon">
                                                    <img src={"/Images/settings.png"} alt="" className="offHover" />
                                                    <img src={"/Images/settings-hover.png"} alt="" className="onHover" />
                                                </figure>
                                                <span className="link_text">Settings</span>
                                                {!dropdownSettingBtn ? (
                                                    <span className="link_icon">
                                                        <i className="fa fa-chevron-right" aria-hidden="true"></i>
                                                    </span>
                                                ) : (
                                                    <span className="link_icon">
                                                        <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                                    </span>
                                                )}
                                            </button>
                                            {dropdownSettingBtn && activeBtn && (
                                                <ul className="childrenDropdown">
                                                    <li>
                                                        <NavLink to="/profile-settings?p01" id="p01" className={window.location.href.split("?")[1] === "p01" ? "activee" : ""} onClick={() => childrenMenu("btn", 1)}>
                                                            Profile Settings
                                                        </NavLink>
                                                    </li>

                                                    <li>
                                                        <NavLink to="/profile-settings?p02" id="p02" className={window.location.href.split("?")[1] == "p02" ? "activee" : ""} onClick={() => childrenMenu("btn", 1)}>
                                                            Upload Logo
                                                        </NavLink>
                                                    </li>
                                                    <li>
                                                        <NavLink to="/profile-settings?p06" id="p06" className={window.location.href.split("?")[1] === "p06" ? "activee" : ""} onClick={() => childrenMenu("btn", 1)}>
                                                            Upload Banner
                                                        </NavLink>
                                                    </li>
                                                    <li>
                                                        <NavLink to="/profile-settings?p04" id="p04" className={window.location.href.split("?")[1] == "p04" ? "activee" : ""} onClick={() => childrenMenu("btn", 1)}>
                                                            Customer Portal
                                                        </NavLink>
                                                    </li>

                                                    <li>
                                                        <NavLink to="/profile-settings?p05" id="p05" className={window.location.href.split("?")[1] == "p05" ? "activee" : ""} onClick={() => childrenMenu("btn", 1)}>
                                                            Reset Password
                                                        </NavLink>
                                                    </li>
                                                    <li>
                                                        <NavLink to="/profile-settings?p07" id="p07" className={window.location.href.split("?")[1] == "p07" ? "activee" : ""} onClick={() => childrenMenu("btn", 1)}>
                                                            Minimum Redeem Value
                                                        </NavLink>
                                                    </li>
                                                    <li>
                                                        <NavLink to="/profile-settings?p08" id="p07" className={window.location.href.split("?")[1] == "p07" ? "activee" : ""} onClick={() => childrenMenu("btn", 1)}>
                                                            Alert Notification
                                                        </NavLink>
                                                    </li>
                                                    <li>
                                                        <NavLink to="/wallet-report" onClick={() => childrenMenu("btn", 1)}>
                                                            Wallet Report
                                                        </NavLink>
                                                    </li>
                                                    <li>
                                                        <NavLink to="/theme" onClick={() => childrenMenu("btn", 1)}>
                                                            Theme
                                                        </NavLink>
                                                    </li>
                                                </ul>
                                            )} */}
                                        </li>
                                    </>
                                )}
                                <li title="Logout">
                                    <NavLink className="link" to="/signin" aria-current="page" onClick={handleLogout}>
                                        <figure className="icon">
                                            <img src={"/Images/logout.png"} alt="" className="offHover" />
                                            <img src={"/Images/logout-hover.png"} alt="" className="onHover" />
                                        </figure>
                                        <span className="link_text">Logout</span>
                                    </NavLink>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="dashboard__mainPage">{children}</div>
            </div>
        </>
    );
};

const mapStateToProps = (state) => ({
    // dropdown:state.dropDownSetting
});

export default connect(mapStateToProps, {})(Sidebar);
